<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppBox from '@/components/app/box.vue';
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import DownloadFileHelper from '@/Helpers/Download.helper';
  export default {
    components: {
      AppBox,
      AppTitleHeader,
    },
    mixins: [DownloadFileHelper],
    props: {
      details: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        selectedImg: '',
        isAttachmentFileModalOpne: false,
      };
    },
    methods: {
      fuelText: function (fuelIndex) {
        switch (fuelIndex) {
          case 1:
            return 'E';
          case 2:
            return 'یک چهارم';
          case 3:
            return 'نصف';
          case 4:
            return 'سه چهارم';
          case 5:
            return 'F';
          default:
            return fuelIndex;
        }
      },
      openAttachmentFileModal: function (src) {
        this.isAttachmentFileModalOpne = true;
        this.selectedImg = src;
      },
      closeAttachmentFile: function () {
        this.isAttachmentFileModalOpne = false;
        this.selectedImg = '';
      },

      downloadAttachment: async function (prependFileName) {
        const image = await fetch(this.selectedImg);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        const link = document.createElement('a');
        const today = new Date();
        link.href = imageURL;
        const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        link.download = `${prependFileName}-${date}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
    },
  };
</script>
<template>
  <v-row class="description-section">
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <app-title-header title="اطلاعات اولیه" />
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col cols="4">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">
                  {{ details?.vehicleDetails?.title }}
                  ({{ details?.vehicleDetails?.code }})
                </div>
                <div>{{ details?.vehicleDetails?.numberPlate }}</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="px-1">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">شیفت</div>
                <div>{{ details?.shift }}</div>
              </app-box>
            </v-col>
            <v-col cols="4">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">وضعیت</div>
                <div>{{ details?.state }}</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="pt-1 pb-0">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">تکنسین ارشد</div>
                <div>{{ details?.seniorTechnician }}</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="pt-1 pb-0 px-1">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">تکنسین اول</div>
                <div>{{ details?.secondTechnicianUser }}</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="pt-1 pb-0">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">پزشک</div>
                <div>{{ details?.doctor }}</div>
              </app-box>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-10">
      <v-row>
        <v-col cols="12">
          <app-title-header title="سوخت" />
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col cols="4">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">سوخت</div>
                <div>{{ fuelText(details?.fuel) }}</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="px-1">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">آخرین کیلومتر ۷۵-۱۰</div>
                <div>{{ details?.lastKM }} کیلومتر</div>
              </app-box>
            </v-col>
            <v-col cols="4">
              <app-box class="description-inner-box items-center">
                <div class="description-inner-box-title">باقی مانده کارت سوخت</div>
                <div>{{ details?.fuelCardRemainder }} لیتر</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="pt-1 pb-0">
              <app-box class="description-inner-box">
                <div class="description-inner-box-title">کیلومتر</div>
                <div>{{ details?.currentKM }} کیلومتر</div>
              </app-box>
            </v-col>
            <v-col cols="4" class="pt-1 pb-0 px-1">
              <v-checkbox
                readonly
                hide-details
                dense
                color="darkColor"
                :value="details?.hasFuelCard"
                label="کارت سوخت"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-10">
      <v-row>
        <v-col cols="12">
          <app-title-header title="توضیحات" />
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col cols="6">
              <app-box class="description-inner-box items-start">
                <div class="description-inner-box-title flex-shrink-0 width-max">نقص فنی</div>
                <div class="description-container">
                  <p>
                    {{ details?.technicalProblemNote }}
                  </p>
                </div>
              </app-box>
            </v-col>
            <v-col cols="6">
              <app-box class="description-inner-box items-start">
                <div class="description-inner-box-title flex-shrink-0 width-max">تصادفات</div>
                <div class="description-container">
                  <p>
                    {{ details?.accidentNote }}
                  </p>
                </div>
              </app-box>
            </v-col>
            <v-col cols="6">
              <app-box class="description-inner-box items-start">
                <div class="description-inner-box-title flex-shrink-0 width-max">توضیحات</div>
                <div class="description-container">
                  <p>
                    {{ details?.note }}
                  </p>
                </div>
              </app-box>
            </v-col>
            <v-col cols="6">
              <app-box class="description-inner-box items-start">
                <div class="description-inner-box-title flex-shrink-0 width-max">وضعیت باکس ها</div>
                <div class="description-container">
                  <p>
                    {{ details?.boxState }}
                  </p>
                </div>
              </app-box>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-10">
      <v-row>
        <v-col cols="12">
          <app-title-header title="تصاویر" />
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col
              v-for="attachments in details?.checkListReportAttachments"
              :key="attachments?.id"
              cols="1"
              class="pa-1"
            >
              <app-box outlined class="mx-auto">
                <v-col class="pa-1">
                  <v-img
                    :src="attachments?.filePath"
                    :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                    aspect-ratio="1"
                    @click="openAttachmentFileModal(attachments?.filePath)"
                  />
                </v-col>
              </app-box>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-10">
      <v-row>
        <v-col cols="12">
          <app-title-header title="کسورات دارویی" />
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col
              v-for="drugShortage in details?.checkListReportDrugShortages"
              :key="drugShortage?.id"
              cols="3"
              class="pa-2"
            >
              <app-box class="mx-auto">
                {{ drugShortage?.drugTitle }}
                ({{ drugShortage?.drugDrugGroupTitle }})
              </app-box>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog width="450" v-model="isAttachmentFileModalOpne">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header pt-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">بارگیری عکس</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeAttachmentFile()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-4">
          <v-row no-gutters>
            <v-col class="pa-2 img-wrapper-box">
              <v-img :src="selectedImg" width="350" fill :aspect-ratio="1" class="mx-auto" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="darkColor"
              dark
              class="normal-letter-spacing px-10 ml-4"
              @click="downloadAttachment(details?.vehicleDetails?.code || 'کد ثبت نشده')"
            >
              بارگیری
            </v-btn>
            <v-btn
              rounded
              outlined
              color="darkColor"
              dark
              @click="closeAttachmentFile()"
              class="normal-letter-spacing px-10 ml-4"
            >
              انصراف
            </v-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style lang="scss" scoped>
  .modal-header {
    border-bottom: 2px solid var(--modal-border-color);
    border-bottom-right-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
    height: 7vh !important;
  }

  .modal-title-text {
    color: var(--dark-color);
    font-weight: 500;
    font-size: 16px;
    margin-left: 0 !important;
  }
  .img-wrapper-box {
    border: 1px solid var(--dark-color);
    border-radius: 16px;
  }
  .w-max {
    width: max-content;
  }
  .description-section {
    height: 75vh;
    overflow-y: auto;
    .description-inner-box {
      display: flex;
      justify-content: space-between;
      gap: 0.5rem;
      font-size: 14px;
      &-title {
        font-weight: 600;
      }
      .description-container {
        height: 110px;
        overflow-y: auto;
      }
    }
  }
</style>
